import React, { useEffect } from 'react';
import Countdown from '../../../../components/Countdown/Countdown';
import ImageSlider from '../../../../components/ImageSlider/ImageSlider';
import LeadForm from '../../../../components/LeadForm/LeadForm';
import { useStateContext } from '../../../../context/ContextProvider';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';
import Footer from '../../../../components/Footer/Footer';
import NoiseBackground from '../../../../components/Background/NoiseBackground';
import Height15 from '../../../../components/Gap/Height';
import LeadFormCRM from '../../../../components/LeadForm/LeadFormCRM';
import ApoelezzLeadForm from '../../../../components/LeadForm/ApoelezzLeadForm';

function BinghattiAquariseApoelezz({
    language
}) {
    const {
        langs,
        langCode
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const images = [
        "/assets/images/projects/binghatti-aquarise/1.webp",
        "/assets/images/projects/binghatti-aquarise/2.webp",
        "/assets/images/projects/binghatti-aquarise/3.webp",
        "/assets/images/projects/binghatti-aquarise/4.webp"
    ];

    const poster = "/assets/images/projects/binghatti-aquarise/1.webp";
    const webm = "/assets/images/projects/binghatti-aquarise/hero.webm";
    const mp4 = "/assets/images/projects/binghatti-aquarise/hero.mp4";

    return (
        <>
            <div>
                {/* LANGUAGE */}
                <LanguageNavigate
                    redirect={language === "ar"
                        ? "/c6ap/binghatti/aquarise"
                        : "/c6ap/binghatti/aquarise/ar"
                    }
                />

                <Height15 />
                <Height15 />

                {/* HEADING */}
                <div className="padding-container text-center my-5 py-5">
                    {language === "ar"
                        ? (
                            <h1 className="text-center px-2 my-1 text-xl">
                                {/* <span className="text-2xl bounce-text secondary-text">
                                    دبي بطابع إيطالي
                                </span> */}
                                تملك شقتك بقلب دبي
                                <span className="text-2xl bounce-text secondary-text">
                                    4
                                </span>
                                دقائق من برج خليفة
                                <br />
                                وفرصتك للحصول علي الإقامة الذهبية
                                <br />
                                لمدة
                                <span className="text-2xl bounce-text secondary-text">
                                    10
                                </span>
                                سنوات
                            </h1>
                        ) : (
                            <>
                                <h1 className="text-center px-2 my-1 text-xl">
                                    Own your apartment in the heart of Dubai,
                                    <span className="text-2xl bounce-text secondary-text">
                                        4 minutes from Burj Khalifa
                                    </span>
                                    !!!
                                    <br />
                                    It's your chance to get the golden residency
                                    <br />
                                    for
                                    <span className="text-2xl bounce-text secondary-text">
                                        10
                                    </span>
                                    years!!!
                                </h1>
                            </>
                        )
                    }
                </div>
            </div >
            {/* IMAGES */}
            <div className="flex w-full justify-center mb-5 pb-5">
                <video
                    autoPlay={true}
                    loop={true}
                    muted={true}
                    playsInline={true}
                    preload="auto"
                    poster={poster}
                    width="350"
                    height="350"
                    className={`max-w-[350px] rounded-3xl`}
                >
                    <source src={webm} type="video/webm" />
                    <source src={mp4} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
            {/* < ImageSlider images={images} /> */}

            {/* <div className="padding-container my-5 py-5">
                {language === "ar"
                    ? (
                        <p className="px-2 my-1">
                            استمتع بأسلوب حياة فاخر في الخليج التجاري - مجموعة رائعة من شقق الاستوديوهات والشقق المكونة من أربع غرف نوم والأجنحة الملكية مع مسابح خاصة. خطة دفع مرنة 20/50/30. التسليم في يونيو 2027.
                        </p>
                    ) : (
                        <>
                            <p className="px-2 my-1">
                                Experience a lavish lifestyle in Business Bay — a striking collection of Studio to 4-bedroom apartments and royal suites with private pools. Flexible 20/50/30 payment plan. Handover by June 2027.
                            </p>
                        </>
                    )
                }
            </div> */}

            <div className="p-5 my-5">
                {/* LEAD FORM */}
                <ApoelezzLeadForm
                    developer="Binghatti"
                    project="Aquarise"
                    leadType="Apartment"
                    language={language === "ar" ? "Arabic" : "English"}
                    enquiries={["Studio", "1 Bedroom", "2 Bedrooms"]}
                />
                {/* <LeadForm
                    developer="Azizi"
                    project="Venice"
                    leadType="Apartment"
                    language={currentLang?.name}
                    client={true}
                    clientId={clientId}
                    clientEmail={clientMail}
                    enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms", "Retail"]}
                /> */}
            </div>
            <Footer />
        </>
    );
}

export default BinghattiAquariseApoelezz;
